import FlightMap from "./mainMap";

export default function Map( {flight,search}) {
  return (
    <div
      style={{
        background: "blue",
        width: "80%",
        display: "flex",
      }}
    >
      <FlightMap  flight={{flight}} search={search}></FlightMap>
    </div>
  );
}
